// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"playerChip__gradient-bg5__OEVio","chip":"playerChip__chip__QLNTH","chipName":"playerChip__chipName__xX54q","chipRemove":"playerChip__chipRemove__NWjue"};